module.exports = " <div class=vux-range-input-box style=position:relative;margin-right:30px;margin-left:50px> <input class=vux-range-input v-model=value number> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/range/index.vue
// module id = 239
// module chunks = 2